import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {maxValidator} from '../max-validator/max-validator';
import {minValidator} from './min-validator';

@Directive({
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: MinDirective
        }
    ],
    selector: '[minimum]'
})
export class MinDirective {
    @Input() public minimum: any;

    constructor() {
    }

    /**
     *
     * @param abstractControl
     */
    public validate(abstractControl: AbstractControl): { [key: string]: any } | null {
        return minValidator(this.minimum)(abstractControl);
    }
}
